<template>
  <div>
    <div
      v-for="(item, itemIndex) in history"
      :key="`event-history-${itemIndex}`"
      class="event-history-card"
      :data-qa="`event-history-${itemIndex}`">
      <div class="event-history-data">
        <span v-if="mixin_isGodMode">
          <span>{{ $d(new Date(item.timeStamp), 'shortDate') }} </span>
          <span>{{ $d(new Date(item.timeStamp), 'longTime') }}</span>
          <span>.{{ new Date(item.timeStamp).getMilliseconds() }}</span>
        </span>
        <span v-else>
          {{ $d(new Date(item.timeStamp), 'longDate') }}
        </span>
      </div>

      <div style="display: flex; flex-wrap: wrap;">
        <UserIcon
          class="avatar"
          :name="item.user"
          size="35"/>
        <div
          class="event-history-item">
          <div class="event-history-row">
            <span
              class="event-history-name"
              :data-qa="`event-history-${itemIndex}-name`">{{ item.user }}</span>
            <span
              class="event-history-event"
              :data-qa="`event-history-${itemIndex}-event`">{{ $t(`Suppliers.eventType.${item.eventType}`) }}</span>
          </div>
          <div
            v-if="item.description"
            class="event-history-reason"
            :data-qa="`event-history-${itemIndex}-description`">
            {{ item.description }}
          </div>
          <div
            v-if="item.comment"
            class="event-history-reason"
            :data-qa="`event-history-${itemIndex}-comment`">
            {{ item.comment }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'

import godModeMixin from 'mixins/godModeMixin'

export default {
  name: 'PurchaseHistory',
  mixins: [ godModeMixin ],
  components: {
    UserIcon
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
    history: {
      type: Array,
      required: true,
    },
  },
}
</script>
<style scoped lang="scss">
.event-history-card {
  text-align: left;
  margin: 0 5px;
  padding-top: 13px;
  color: var(--black-color);
}
.event-history-data {
  font-size: 12px;
  line-height: 14px;
  padding: 0 0 5px 5px;
  color: rgba(var(--black-color-rgba), 0.5);
}
.event-history-item {
  display: flex;
  flex-wrap: wrap;
  width: calc(100% - 35px);
}
.event-history-row {
  padding-top: 7px;
}
.event-history-name {
  font-weight: 500;
  padding-left: 8px;
  margin: auto 0 auto 2px;
  padding-top: 5px;
  font-size: 14px;
  line-height: 18px;
}
.event-history-event {
  padding-left: 7px;
  margin: auto 0;
  text-decoration: underline;
  padding-top: 5px;
}
.event-history-reason {
  background: var(--color-main-green);
  border-radius: 0 25px 25px 25px;
  padding: 13px 15px 15px 15px;
  line-height: 18px;
  margin-top: 10px;
  width: 100%;
}
</style>
